// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"7dbbf8b3","287":"787ba67e","290":"4532fe68","344":"765ea683","550":"368ab860","608":"04bb31a5","841":"93daba88"}[chunkId] + ".chunk.js";
};